:host {
  display: block;
  max-width: 375px;
}

.button-text {
  gap: 8px;
  display: flex;
  align-items: center;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
}

.button-error {
  display: flex;
  justify-content: center;
  letter-spacing: 0.52px;
  filter: invert(12%) sepia(91%) saturate(6409%) hue-rotate(9deg) brightness(86%) contrast(109%);
  margin-top: 8px;
  font-family: 'Lato';
  font-size: 13px;
  align-items: center;
}
